export const PAGINATION_LIMIT_DEFAULT = "3";
export const ALL_IPO = "all";
export const IPO_TYPE = {
	CURRENT: "current",
	UPCOMING: "upcoming",
	CLOSED: "closed",
};
export const IPO_PLACEHOLDER = "https://cms-assets.bajajfinserv.in/is/image/bajajfinance/IPOplaceholder";
export const currencySymbol = "\u20b9";
export const IPO_TEXT = " IPO";
export const PRE_APPLY = "PRE-APPLY";
export const MAINBOARD = "mainboard";
export const SME = "sme";

export type IpoListSubType = typeof MAINBOARD | typeof SME;
